export const DEFAULT_CLINICAL_REPORT_AI_MODEL = 'gemini-3.5-flash-lite';
